import { AssistantWrapper } from "@/commands/AIConcierge/assistantWrapper";

export default function AIConcierge() {
  return <AssistantWrapper />;
}
